// src/features/tasks/services/completionReceipt.js
import { apiClient } from '../../../services/api/client';

export const completionReceiptAPI = {
  // Get completion receipt for a task
  getReceipt: (taskId) =>
    apiClient.get(`/api/v1/task-management/tasks/${taskId}/completion-receipt`),

  // Sign completion receipt
  signReceipt: (taskId, data) =>
    apiClient.post(`/api/v1/task-management/tasks/${taskId}/completion-receipt/sign`, data),
};
